import { OPENING_ACTIONS } from '../../constants/actionTypes';
const { RECEIVE_OPENING } = OPENING_ACTIONS;

const initialState = {
  fen_moves: [],
  san_moves: [],
};

function openingsReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_OPENING: {
      const { opening } = action;

      return opening;
    }
    default:
      return state;
  }
}

export default openingsReducer;



